import { Descriptions } from "antd";
import { ApplicantUserCitizenship } from "../../../../generated";
import { Country } from "../../../../types/country";
import { ProfileHeaderContainer } from "./profile-header.container";

const TITLE = "Citizenship Details";

interface ApplicantProfileCitizenshipViewProps {
  citizenship: ApplicantUserCitizenship | null | undefined;
  countries: Country[];
  onEditToggle: () => void;
}

export const ApplicantProfileCitizenshipView: React.FC<ApplicantProfileCitizenshipViewProps> = ({
  citizenship,
  countries,
  onEditToggle,
}) => {
  return (
    <div>
      <ProfileHeaderContainer title={TITLE} onEdit={onEditToggle} />
      <Descriptions
        title={undefined}
        layout="vertical"
        size="small"
        column={1}
        className="w-[400px]"
      >
        {citizenship?.currentCitizenOf?.map((citizenCountryCode, index) => (
          <Descriptions.Item
            label={index === 0 ? "Current Citizen of" : undefined}
            key={citizenCountryCode}
          >
            {
              countries?.find(
                (country) => country.countryCode === citizenCountryCode
              )?.countryName
            }
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
};
